import React from 'react';
import ReactSelect, { SingleValue } from 'react-select';
import { ConditionSelectorOption, ConditionSelectorProps } from './interface';
import { useConditions } from './useConditions';
import useDebouncedSearchTerm from '../../hooks/useDebouncedSearchTerm';
import { isString } from './utils';
import useConditionOptions from './useConditionOptions';

function ConditionSelector(props: ConditionSelectorProps) {
  const { value: conditionId, onChange } = props;

  const { setValue, immediateValue, debouncedValue } = useDebouncedSearchTerm();
  const { conditions } = useConditions(debouncedValue);

  const { options, selectedOption } = useConditionOptions({
    conditions,
    selectedConditionId: conditionId
  });

  const handleSelectChange = (option: SingleValue<ConditionSelectorOption>) => {
    if (isString(option?.value)) {
      onChange(option.value);
    }
  };

  return (
    <ReactSelect
      placeholder="Enter condition name"
      options={options}
      value={selectedOption}
      inputValue={immediateValue}
      onInputChange={setValue}
      onChange={handleSelectChange}
    />
  );
}

export default ConditionSelector;
